import React, { useState, useEffect } from 'react';
import WhiteLabel from 'utils/whitelabel';
import RatingEngineModal from 'components/ui/modals/RatingEngineModal';
import qs from 'qs';
import { useTranslation } from 'react-i18next';
export default function LandingModule() {
    const { t } = useTranslation();
    const [pictureUrl, setPictureUrl] = useState('');
    const [clientName, setClientName] = useState('');
    const [logo, setLogo] = useState('');
    const pathIncludesModalVal = qs.parse(window.location.search, {
        ignoreQueryPrefix: true,
    });
    const [ratingEngineModal, setRatingEngineModal] = useState(!!pathIncludesModalVal.confirmLaneRates ||
        !!pathIncludesModalVal.confirmAccessorialRates);
    const [ratingEngineModalType, setRatingEngineModalType] = useState(pathIncludesModalVal.confirmLaneRates === 'true' ||
        pathIncludesModalVal.confirmAccessorialRates === 'true');
    const [ratingEngineModalFrom, setRatingEngineModalFrom] = useState(pathIncludesModalVal.confirmLaneRates ? '' : 'Accessorial');
    const [ratingEngineModalRateType, setRatingEngineModalRateType] = useState(pathIncludesModalVal.confirmLaneRates === 'true' ||
        pathIncludesModalVal.confirmLaneRates === 'false'
        ? 'LaneRates'
        : 'LaneAccessorialRates');
    const [ratingEngineModalToken, setRatingEngineModalToken] = useState(pathIncludesModalVal.token ? pathIncludesModalVal.token : '');
    useEffect(() => {
        const getAssets = async () => {
            try {
                const fetchedLogo = WhiteLabel.getClientLogo();
                const fetchedClientName = WhiteLabel.getClientName();
                setPictureUrl(`${CDN_URL}/assets/truck.jpg`);
                setLogo(fetchedLogo);
                setClientName(fetchedClientName);
            }
            catch (e) {
                console.error('LandingModule, failed to get signed URL: ', e);
            }
        };
        getAssets();
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "relative w-full bg-white" },
            React.createElement("div", { className: "hidden sm:block" },
                React.createElement("img", { className: "w-full", alt: "Cargomatic", src: pictureUrl }),
                React.createElement("div", { style: { position: 'absolute', left: '50%', top: '57%' } },
                    React.createElement("img", { alt: "Cargomatic", src: logo, width: 400 }))),
            React.createElement("div", { className: "px-4 py-6 sm:p-6 sm:absolute sm:inset-0 sm:py-16 sm:px-16" },
                React.createElement("div", { className: "overflow-y-hidden" },
                    React.createElement("h2", { className: "my-0 mb-2" }, t('WELCOME_PAGE_CLIENTNAME', { clientName })),
                    React.createElement("h4", { className: "my-0 mb-2" }, t('WELCOME_PAGE_CARGOMATIC_MOTO')),
                    React.createElement("h4", { className: "my-0" }, t('WELCOME_PAGE_INFO'))))),
        ratingEngineModal && (React.createElement(RatingEngineModal, { show: ratingEngineModal, onCloseClick: () => setRatingEngineModal(), from: ratingEngineModalFrom, rateType: ratingEngineModalRateType, type: ratingEngineModalType, token: ratingEngineModalToken }))));
}
